import React from 'react';
import styled from 'styled-components';
import {
  Row, Col, Button, Container,
} from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import toastr from 'toastr';

import SweetAlert from 'react-bootstrap-sweetalert';
import Content from '../components/layout/Content';
import { getTabletOrderCounts, getCounts } from '../api/count';
import { getTablets, clearTablets } from '../api/tablet';
import Loading from '../components/Loading';
import Tablet from '../components/Tablet';
import { fetchTablets } from '../redux/actions/tablet';
import { logout } from '../api/auth';
import { logOutAction } from '../redux/actions/auth';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderCounts: [],
      totalCounts: [],
      sweetAlert: false,
    };
  }

  async componentDidMount() {
    const { user, dispatch } = this.props;
    // console.log('user', user);
    if (user.errorMessage) {
      console.log('user.errorMessage', user.errorMessage);
      toastr.error(user.errorMessage);
      return;
    }
    if (user.error) {
      console.log('user.error', user.error);
      toastr.error(user.error);
      return;
    }
    // const masterUser = user.masterUser || user.id;
    const masterUser = user && (user.masterUserId || user.id);
    const res = await getTablets(masterUser);
    // console.log('getTablets res', res);
    const { data: { tablets } } = res;
    const tabletMacAddress = tablets.map((tablet) => tablet.macAddress);
    // console.log('-----');
    console.log(tabletMacAddress);
    const counts = await getTabletOrderCounts(tabletMacAddress);
    // console.log('counts', counts);
    const totalCounts = await getCounts(masterUser);
    // console.log('totalCounts', totalCounts);
    dispatch(fetchTablets());
    this.setState({ orderCounts: counts.data.counts, totalCounts: totalCounts.data });
  }

  tabletClear = async () => {
    this.setState({ sweetAlert: false });
    const { user, history, intl } = this.props;
    const tabletsCleared = intl.formatMessage({ id: 'clear.tablet.success' });
    const errorText = intl.formatMessage({ id: 'error' });
    const masterUser = user && (user.masterUserId || user.id);
    await clearTablets(masterUser).then((result) => {
      toastr.success(tabletsCleared);
      this.timeout = setTimeout(() => {
        history.go(0);
      }, 500);
    }, (error) => {
      console.log('error', { error });
      toastr.error(errorText);
    });
  }

  render() {
    const { tablets, intl } = this.props;

    const { orderCounts, totalCounts, sweetAlert } = this.state;

    const tabletsText = intl.formatMessage({ id: 'home.tablets' });
    const statisticText = intl.formatMessage({ id: 'home.statistic' });
    const categoryCountText = intl.formatMessage({ id: 'home.categoryCount' });
    const productCountText = intl.formatMessage({ id: 'home.productCount' });
    const tabletCountText = intl.formatMessage({ id: 'home.tabletCount' });
    const orderCountText = intl.formatMessage({ id: 'home.orderCount' });

    const confirmText = intl.formatMessage({ id: 'confirm' });
    const areYouSureText = intl.formatMessage({ id: 'areyousure' });
    const cancelText = intl.formatMessage({ id: 'cancel' });
    const clearTabletsText = intl.formatMessage({ id: 'clear.tablet' });

    if (!Array.isArray(orderCounts)) {
      return (<Loading />);
    }
    return (
      <div>
        <Content title={tabletsText} tablet onClick={() => this.setState({ sweetAlert: true })} text={clearTabletsText}>

          <div>
            <Row>
              <Col>
                <Row>
                  {
                    tablets.map((tablet, index) => {
                      const key = `tablet-${index}`;
                      const title = tablet.displayName || tablet.ipAddress;
                      return (
                        (
                          <Col md="4" key={key}>
                            <Tablet
                              title={title}
                              tablet={tablet}
                              orderCounts={orderCounts}
                              index={index}
                            />
                          </Col>
                        )
                      );
                    })
                  }
                </Row>

              </Col>
            </Row>
          </div>
        </Content>
        <Content title={statisticText}>
          <StatisticWrapper>
            <Col>
              <Row>
                <Col md="3">
                  <CardWrapper>
                    <CardTitle>{categoryCountText}</CardTitle>
                    <CardContent>{totalCounts.categoriesCount}</CardContent>
                  </CardWrapper>
                </Col>
                <Col md="3">
                  <CardWrapper>
                    <CardTitle>{productCountText}</CardTitle>
                    <CardContent>{totalCounts.productCount}</CardContent>
                  </CardWrapper>
                </Col>
                <Col md="3">
                  <CardWrapper>
                    <CardTitle>{tabletCountText}</CardTitle>
                    <CardContent>{tablets.length}</CardContent>
                  </CardWrapper>
                </Col>
                <Col md="3">
                  <CardWrapper>
                    <CardTitle>{orderCountText}</CardTitle>
                    <CardContent>{totalCounts.orderCount}</CardContent>
                  </CardWrapper>
                </Col>
              </Row>
            </Col>
          </StatisticWrapper>
          <SweetAlert
            show={sweetAlert}
            warning
            showCancel
            cancelBtnText={cancelText}
            confirmBtnText={confirmText}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={areYouSureText}
            onConfirm={this.tabletClear}
            onCancel={() => this.setState({ sweetAlert: false })}
          />
        </Content>
      </div>
    );
  }
}


const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 150px;
  background-color: #DE3939;
  color: white;
  margin-bottom: 10px;
  border-radius: 3px;
`;
const CardTitle = styled.span`
  font-size: 1rem;
`;
const CardContent = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
`;

const StatisticWrapper = styled(Row)`
`;

Home.propTypes = {
  intl: intlShape.isRequired,
  user: PropTypes.shape({
    isAdmin: PropTypes.number,
    id: PropTypes.number,
    masterUser: PropTypes.oneOf([PropTypes.number, null]),
    error: PropTypes.any,
    errorMessage: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  tablets: PropTypes.array.isRequired,
  history: PropTypes.any.isRequired,
};

const mapStateToProps = (state, dispatch) => ({
  tablets: state.tablets,
  user: state.auth.user,
  dispatch,
});

export default injectIntl(connect(mapStateToProps)(Home));
